import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  loading: {
    id: 'product_page_upgrade_loading',
    defaultMessage: 'Scanning for best price',
  },
  upgraded: {
    id: 'product_page_upgrade_upgraded',
    defaultMessage: 'Smart upgrade applied',
  },
  canUpgrade: {
    id: 'product_page_upgrade_multiple_fields',
    defaultMessage:
      'Pay less and get better specs Pay less and get better specs',
  },
  title: {
    id: 'product_page_upgrade_title',
    defaultMessage: 'Great deal alert',
  },
} as Record<string, I18nDefinition>
